<div *ngIf="isMaintenanceModeActive">
  <h1>Ce site est temporairement inaccessible.</h1>

  <p>Dès que les ajustements nécessaires seront terminés, vous en serez informés grâce à l'Infolettre AEP.</p>

  <p>Pour toute question, communiquez avec : <a href="mailto:aep@fcssq.quebec">aep@fcssq.quebec</a></p>
</div>

<div *ngIf="!isMaintenanceModeActive" class="container" style="max-width:1250px;">
  <div class="banniere">
    <img src="../../../assets/images/ImageAccueil.png" />
  </div>

  <div style="background-color:whitesmoke;">
    <div style="padding: 40px 165px 30px 165px">
      <p>L’harmonisation des programmes d’études professionnelles et techniques est une orientation ministérielle. Elle consiste à établir des similitudes entre les compétences et à assurer la continuité entre les programmes d’études. Pour les programmes menant à une AEP, l’harmonisation s’effectue à l’ordre d’enseignement secondaire, et ce, dans un même secteur de formation ou, s’il y a lieu, dans des secteurs différents. L’harmonisation vise à éviter la duplication des offres de formation, à reconnaître les compétences acquises et à faciliter les parcours de formation. Au moment d’élaborer un programme, ces facteurs doivent être pris en considération.</p>
      <p>Ainsi, au moment de l’inscription dans un programme d’études, les tableaux d’harmonisation permettent d’identifier ces compétences communes et de les sanctionner dans le système ministériel de déclaration des effectifs scolaires.</p>
      <p>Ces compétences peuvent être identiques ou équivalentes. Comme leur nom l’indique, les compétences identiques sont reprises intégralement d'un programme d'études à l'autre. Elles possèdent par conséquent le même code ministériel. Pour leur part, les compétences équivalentes sont des compétences pour lesquelles les travaux d'harmonisation ont permis d'établir qu'elles sont similaires à 80&nbsp;% ou plus en ce qui a trait à leur teneur et à leur portée. Les compétences équivalentes possèdent des codes distincts.</p>
      <p style="text-align: center; font-weight:600;"><a href="../declarations/" style="color:#333333;">Consulter la déclaration des équivalences</a></p>
    </div>
  </div>

  <div style="margin-top:30px;margin-bottom:60px;text-align:center !important;">
    <input type="button" value="Consulter les tableaux d&rsquo;harmonisation"  class="btn btn-info" routerLink="/tableaux" />
  </div>

  <div class="col-12 credits">
    <hr />
    <p>
      <strong>Coordination des travaux</strong><br />
      Fédération des centres de services scolaires du Québec
    </p>
    <p>
      <strong>Encadrement des travaux</strong><br />
      Direction de la formation professionnelle<br />
      Ministère de l’Éducation du Québec
    </p>
    <hr />
  </div>

</div>
